export default __webpack_public_path__ + "static/media/MySQL-WindowsTaskScheduler-Properties08.fb49194d.png";